import styled from 'styled-components';
import { ThemeColours } from '../../../../common/styles/ThemeColours';
import { FontWeight, LINK_STYLE } from '../../../../common/styles/constants';
import { onMobile } from '../../../../common/styles/onMobile';
import Image from '../../NoResults/NoResults.color.svg';

export const EndOfResultsContainer = styled.div`
  text-align: left;
  width: 100%;
`;

export const Card = styled.div`
  align-items: center;
  background-color: ${ThemeColours.mono100};
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  margin: 0 0 80px;
  padding: 24px;

  ${onMobile} {
    flex-direction: column;
    padding: 40px;
    text-align: center;
  }
`;

export const StyledImage = styled(Image)`
  height: 30px;
  width: 30px;
`;

export const Message = styled.div`
  margin-inline-start: 20px;

  ${onMobile} {
    margin-inline-start: 0;
  }
`;

export const HintHeader = styled.div`
  color: ${ThemeColours.black};
  font-size: 20px;
  font-weight: ${FontWeight.SEMI_BOLD};

  ${onMobile} {
    font-size: 16px;
    line-height: 26px;
    margin-top: 16px;
  }
`;

export const Hint = styled.div`
  color: ${ThemeColours.mono700};
  font-size: 16px;
  line-height: 26px;
`;

export const HintListItemLink = styled.a`
  ${LINK_STYLE}
`;
